<template>
  <OnboardingLayout
    title="Payment Summary"
    description="Join the thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
    @onButtonClick="submitForm"
    imageDescription="System ownership is transferred immediately payment is made"
    :imageUrl="require('@/assets/img/female-wave.gif')"
    :canContinue="canContinue"
    :loading="showLoading"
  >
    <div class="summary-container">
      <div class="summary">
        <el-form
          ref="form"
          :rules="{
            numInverters: [
              {
                required: true,
                message: 'Please enter the Number of Systems',
                trigger: 'blur'
              },
              { validator: validateNumInverters, trigger: 'blur' }
            ],
            installationAddress: [
              {
                required: true,
                message: 'Please enter the installation address',
                trigger: 'blur'
              }
            ],
            customerRegion: [
              {
                required: true,
                message:
                  'Please select the closest installation address region',
                trigger: 'change'
              }
            ],
            buildingType: [
              {
                required: true,
                message: 'Please select the building type',
                trigger: 'change'
              }
            ]
          }"
          :model="formData"
        >
          <el-form-item label="Number of Systems" prop="numInverters">
            <el-input
              placeholder="Number of Systems"
              v-model="formData.numInverters"
              @change="checkCanContinue"
              type="number"
            ></el-input>
          </el-form-item>
          <div class="grid">
            <el-form-item label="Building Type" prop="buildingType">
              <el-select
                v-model="formData.buildingType"
                placeholder="Select building type"
                @change="handleChangeCustomerRegion"
              >
                <el-option
                  label="Storage Only"
                  value="storage_only"
                ></el-option>
                <el-option label="Bungalow" value="bungalow"></el-option>
                <el-option label="1 Storey" value="1_storey"></el-option>
                <el-option label="2 Storey" value="2_storey"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Region" prop="customerRegion">
              <el-select
                v-model="formData.customerRegion"
                @change="handleChangeCustomerRegion"
                placeholder="Select"
                filterable
              >
                <el-option
                  v-for="location in locations"
                  :key="location.key"
                  :label="location.value"
                  :value="location.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="Installation Address" prop="installationAddress">
            <el-input
              v-model="formData.installationAddress"
              @change="checkCanContinue"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="summary-table">
          <div>
            <p>Equipment cost</p>
            <p>
              NGN
              {{
                Intl.NumberFormat("en-US").format(
                  +selectedProduct.equipment_cost * +formData.numInverters
                )
              }}
            </p>
          </div>
          <!-- <div>
            <p>Amount OS</p>
            <p>
              NGN
              {{
                Intl.NumberFormat("en-US").format(
                  +selectedProduct.amountOS * +formData.numInverters
                )
              }}
            </p>
          </div> -->
          <div>
            <p>Installation cost</p>
            <p>
              NGN
              {{ Intl.NumberFormat("en-US").format(+installation_cost) }}
            </p>
          </div>
          <div>
            <p>Logistics cost</p>
            <p>
              NGN
              {{ Intl.NumberFormat("en-US").format(+logistics_cost) }}
            </p>
          </div>
          <div>
            <p>Maintenance fee</p>
            <p>
              NGN
              {{
                Intl.NumberFormat("en-US").format(
                  +selectedProduct.maintenance_fee * +formData.numInverters
                )
              }}
            </p>
          </div>
          <!-- <div>
            <p>Caution fee (Refundable)</p>
            <p>
              NGN
              {{
                Intl.NumberFormat("en-US").format(
                  selectedProduct.monthlyAmountLO * +formData.numInverters
                )
              }}
            </p>
          </div> -->
          <!-- <div class="bold-text">
                <p>Starting Monthly Payments</p>
                <p>
                  NGN {{ Intl.NumberFormat("en-US").format(monthlyPaymentValue) }}
                </p>
              </div> -->
        </div>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
import { mapGetters } from "vuex";
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import { Form, FormItem } from "element-ui";
import locationsData from "@/data/location.json";
import CalculatorService from "@/services/calculator.js";
import OnboardingService from "@/services/onboarding.js";

export default {
  components: {
    OnboardingLayout,
    "el-form": Form,
    "el-form-item": FormItem
  },
  computed: {
    ...mapGetters(["getUserSession"])
  },
  created() {
    this.locations = locationsData;
  },
  watch: {
    quantity(newValues, oldValues) {
      if (!newValues) return;
      // this.selectedProduct = {
      //   firstPaymentAmt: 3 * +this.loAmount * newValues,
      //   cautionFee: +this.loAmount * newValues,
      //   monthlyPaymentValue: +this.loAmount * newValues
      // };
    }
  },
  data() {
    return {
      showLoading: false,
      canContinue: false,
      formData: {
        numInverters: 1,
        installationAddress: "",
        customerRegion: "",
        buildingType: ""
      },
      selectedProduct: {},
      nextPageName: "OnboardContractUpload", //
      logistics_cost: 0,
      installation_cost: 0
    };
  },
  methods: {
    async handleChangeCustomerRegion() {
      this.checkCanContinue();
    },
    checkCanContinue() {
      this.calculateLogisticsCost();
      this.calculateInstallationCost();
      const { numInverters, installationAddress, buildingType } = this.formData;
      if (numInverters && installationAddress && buildingType) {
        this.canContinue = true;
      } else {
        this.canContinue = false;
      }
    },
    async calculateLogisticsCost() {
      if (!this.formData.customerRegion) {
        this.logistics_cost = 0;
      }
      try {
        const res = await CalculatorService.logisticsCost({
          arnergyProductId: this.selectedProduct.id,
          customerRegion: this.formData.customerRegion,
          buildingType: this.formData.buildingType,
          numInverters: this.formData.numInverters
        });
        this.logistics_cost = res.data;
        // await this.calculateTotalUpfront();
      } catch (error) {}
    },
    async calculateInstallationCost() {
      if (!this.formData.buildingType) {
        this.installation_cost = 0;
      }
      try {
        const res = await CalculatorService.installationCost({
          arnergyProductId: this.selectedProduct.id,
          buildingType: this.formData.buildingType,
          numInverters: this.formData.numInverters
        });
        this.installation_cost = res.data;
        // await this.calculateTotalUpfront();
      } catch (error) {}
    },
    validateNumInverters(rule, value, callback) {
      if (value < 1) {
        callback(new Error("Number of Systems must be at least 1"));
      } else {
        callback();
      }
    },
    async updateDBData(payloadData) {
      try {
        this.showLoading = true;

        const res = await OnboardingService.updateDbData({
          ...payloadData,
          product_id: this.selectedProduct.id,
          currentPageName: this.nextPageName
        });
        this.showLoading = false;

        if (res) {
          this.navTo(this.nextPageName);
        }
      } catch (error) {
        console.log({ error });
        this.showLoading = false;
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.updateDBData({
            ...this.formData,
            product_id: this.selectedProduct.id
          });
        } else {
          // Form validation failed
        }
      });
    }
  },
  mounted() {
    this.selectedProduct = this.$store.state.onboardingCustomerState.selectedProduct;
  }
};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.downPayment {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}
.tenureMonth {
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.buildingType {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.address {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
    // font-weight: normal;
  }
}

.quantity label {
  font-size: 16px;
  color: #727272;
  // font-weight: normal;
}
.quantity input {
  width: 50px;
  border-radius: 6px;
  height: 30px;
  margin-left: 6px;
  border: 1px solid #d3d9dd;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.summary-container {
  width: 100%;
  max-width: 527px;
}

.summary {
  // width: 55%;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > div {
    width: 100%;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 17px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p {
        color: #000000;
        font-size: 16px;
      }

      p:last-child {
        text-align: left;
        width: 30%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .bold-text p {
      font-weight: bold;
    }

    .tabbed {
      position: relative;
    }

    .tabbed p {
      margin-left: 55px;
    }

    .tabbed .arrows {
      position: absolute;
      bottom: 30px;
      left: 25px;
    }
  }

  .tenure-section {
    margin-bottom: 30px;

    h4 {
      color: #fe7a11;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .tenure-bar {
      display: flex;
      justify-content: space-between;

      .point {
        text-align: center;
        position: relative;
        width: 15px;
        overflow-x: visible;
        cursor: pointer;

        &:first-child {
          cursor: text;
        }

        &:last-child {
          text-align: right;
        }

        p {
          color: #efefef;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 2px;
          height: 20px;
        }

        div {
          width: 3px;
          height: 8px;
          border-radius: 2px;
          background: #efefef;
          display: inline-block;
        }

        div.active {
          background: #ace5ff;
        }

        p.marked {
          padding: 2px 8px;
          border-radius: 5px;
          background: #0892d0;
          width: 80px;
          margin-left: -32.5px;
        }

        div.marked {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #0892d0;
        }
      }
    }

    .base-line {
      background: #efefef;
      height: 5px;
      border-radius: 9px;
      margin-top: -14px;

      .blue-line {
        width: 82.5%;
        height: 5px;
        background: #ace5ff;
        border-radius: 9px;
      }
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/standard/os/payment-summary/index.vue